export const loadingGoalsData = {
    departments: [
        {
            goal: {},
            users: [{goal: {}}, {goal: {}}, {goal: {}}, {goal: {}}]
        },{goal: {}},{goal: {}},{goal: {}},{goal: {}},{goal: {}}
    ],
    goal: {}
}